import React from 'react';
import { ComHeader } from './ComHeader';
import { Col, Layout, Row } from 'antd';
import AppFooterBar from './AppFooterBar';
import AppSiderBar from './AppSiderBar';
import AppNavbar from '@components/app-navbar/AppNavbar';
import styles from '@styles/Layout.module.scss';

export default function AppLayout({
    children,
    menuInfos,
    siderBarInfos,
    footerInfos,
    routerPath,
    title,
    rgpBanner,
}: any) {
    const { Header, Footer, Sider, Content } = Layout;
    return routerPath[0] === 'info' ? (
        <Layout style={{ background: '#e7e7e7' }}>
            <ComHeader title={title} />
            <Content>{children}</Content>
            <Footer>
                <AppFooterBar footerInfos={footerInfos} rgpBanner={rgpBanner} />
            </Footer>
        </Layout>
    ) : (
        <Layout style={{ background: '#e7e7e7' }}>
            <ComHeader title={title} />
            <Header>
                <AppNavbar menuInfos={menuInfos}></AppNavbar>
            </Header>
            {/* <Sider className='sideContainer' width='auto'>
                </Sider> */}
            <Content className={styles.layoutContain}>
                <Row gutter={12}>
                    <Col
                        md={6}
                        lg={5}
                        sm={24}
                        xxl={6}
                        xl={5}
                        xs={24}
                        className={styles.layoutSider}
                    >
                        <AppSiderBar siderBarInfos={siderBarInfos} routerPath={routerPath} />
                    </Col>
                    <Col md={18} lg={19} sm={24} xxl={18} xl={19} xs={24}>
                        <div className='md:rounded'>{children}</div>
                    </Col>
                </Row>
            </Content>
            <Footer>
                <AppFooterBar footerInfos={footerInfos} rgpBanner={rgpBanner} />
            </Footer>
        </Layout>
    );
}
